import { TableColumnName, TableConfig } from '@common/types';

export const getIndexActiveColumn = (config: TableConfig, columnKey: TableColumnName) => {
  const activeColumns = config?.columns.filter((column) => column.active);
  return activeColumns?.findIndex(({ key }) => key === columnKey);
};
